












import PrefixesPopular from "@/components/PrefixesPopular.vue";
import { Prefix, PrefixPopularItems } from "@/types/debug-mode";
import GetPrefixPopularItems from "@/mixins/get-prefix-popular-items";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { State } from "vuex-class";

@Component({ components: { PrefixesPopular } })
export default class PrefixSubPrefixes extends Mixins(GetPrefixPopularItems) {
  created() {
    this.getPrefixPopularItems(this.prefix.id);
  }

  beforeDestroy() {
    this.cleanUpPrefixPopularItems();
  }

  @State(state => state.debugMode.prefixPopularItems)
  prefixPopularItems!: PrefixPopularItems;

  @Prop({ required: true })
  prefix!: Prefix;

  get popularItems() {
    return this.prefixPopularItems[this.prefix.id];
  }

  get popularPrefixes() {
    if (this.popularItems) {
      return this.popularItems.popular_prefixes;
    }
    return [];
  }
}
